import { BorderGridContainer, GridBox, H1, HeroBanner, PortableText } from '@ahmdigital/ui';
import { useRouter } from 'next/router';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';
import React, { useState } from 'react';
import styled from 'styled-components';

import {
  ContentWrapper,
  HeaderWrapper,
  OverflowWrapper,
  PlaneVideoWrapper,
  StyledAlert,
  SubtitleWrapper,
  TitleSection,
  TitleWrapper,
} from './styles';
import { ImageType } from '../../../../types/image';
import { SANITY_MEDIA_FILES } from '../../../../ahm-constants/ui';
import { SectionOfferStrip } from '../../../insurance/types';
import { TravelWidgetProvider } from './hooks/travel-widget-context';
import device from '../../../../utils/device';
import WidgetWrapper from './components/widget-wrapper';
import type { Alert as AlertType } from '../../../../types/__codegen__/sanity/graphql';
import type { PortableTextType } from '../../../../types/sanityInternal';

type Props = {
  title: PortableTextType[];
  offer: SectionOfferStrip;
  image?: ImageType;
  subtitle?: PortableTextType[];
  announcement?: AlertType & {
    insuranceType?: string | null;
  };
};

// The styles are injected by the Product Review widget, the only way to override them is to use a wrapper
const ProductReviewInjectElementWrapper = styled.div`
  svg {
    width: 8rem !important;
  }
`;

const ProductReviewInjectElement = <ProductReviewInjectElementWrapper id="pr-rich-rating-badge-widget" />;

const Header = ({ title, offer, image, subtitle, announcement }: Props) => {
  const [isWidgetActive, setIsWidgetActive] = useState(false);
  const router = useRouter();
  const { productOptionValue } = router.query;

  const FooterContent = (
    <TravelWidgetProvider>
      <WidgetWrapper
        isWidgetActive={isWidgetActive}
        offer={offer}
        setIsWidgetActive={setIsWidgetActive}
        productOptionValue={productOptionValue as string}
      />
    </TravelWidgetProvider>
  );
  if (productOptionValue) {
    return (
      <HeroBanner
        title={title}
        subtitle={subtitle}
        image={device.isLargeTabletOrMobile() ? null : image}
        footer={FooterContent}
      />
    );
  }

  return (
    <BorderGridContainer hideBorderTop>
      <GridBox padding="0">
        {announcement && (
          <StyledAlert showIcon={false} analyticsLabel="Travel insurance information" level={announcement?.level}>
            <PortableText source={announcement?.descriptionRaw} />
          </StyledAlert>
        )}
        <HeaderWrapper>
          <OverflowWrapper>
            <PlaneVideoWrapper>
              <video autoPlay muted playsInline height="500px">
                <source src={SANITY_MEDIA_FILES.PLANE_VIDEO} type="video/mp4" />
              </video>
            </PlaneVideoWrapper>
          </OverflowWrapper>
          <ContentWrapper>
            <TitleSection>
              <TitleWrapper>
                <H1 variant="marginBottomSpacer11">{portableTextToPlain(title)}</H1>

                {ProductReviewInjectElement}
                <SubtitleWrapper>
                  <PortableText source={subtitle} />
                </SubtitleWrapper>
              </TitleWrapper>
            </TitleSection>
            {FooterContent}
          </ContentWrapper>
        </HeaderWrapper>
      </GridBox>
    </BorderGridContainer>
  );
};

export default Header;
